module.exports = __webpack_public_path__ + "static/img/card_icon_data@2x.f9300ba8.png";